
export default {
    name: 'CategoryBaseForm',
    data() {
        return {
            action: '',
            category: {
                categoryId: '',
                name: '',
                description: ''
            }
        }
    },
    methods: {
        setAction(actionParam) {
            this.action = actionParam;
        },
        clearCategory() {
            this.$router.push('/categories');
        },
        async handleBtnSave() {
            await this.$store.dispatch(this.action, this.category);
            this.clearCategory();
        },
        handleBtnCancel() {
            this.clearCategory();
        } 
    },

}